import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AddContactPersonPage } from './add-contact-person.page';

const routes: Routes = [
  {
    path: '',
    component: AddContactPersonPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AddContactPersonPageRoutingModule {}
